import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.scss';

const MechanismSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section id="mehanizam" className="mechanism-section">
      <div className="mech-wrapper">
        {/* Leva strana: tekst i motor */}
        <div className="mech-left">
          <h2 className="font-upercase">NAGRADNI KONKURS KOJI OSVAJA!</h2>
          <h3 className="font-secondary-title">OSVOJI AOC AGON MONITOR</h3>
          <img
            src="../glavna-nagrada-aoc.png"
            alt="Yamaha motor"
            className="mech-motor img-fluid"
          />
        </div>

        <div className="mechanism-mobile-divider">
          <h1 className='text-galvna'>GLAVNA NAGRADA</h1>
           {/* <img src="../PRESS.png" alt="Divider" className="press-divider-mehanism" /> */}
          <h2 className='text-yamaha'>AOC AGON MONITOR</h2>
        </div>

        {/* Desna strana: tabela kao slika + tekst preko */}
        <div className="mechanism-scale-wrapper">
          <img
            src="../proba-mehanizam-2.png"
            alt="Tabela prijava"
            className="mechanism-table img-fluid"
          />
          <div className="mechanism-scale-inner">
            <div className="line-box line-box-1">
              <div className="title title-1">SKENIRAJ QR KOD</div>
              <div className="desc desc-1">Skenirajte qr kod koji se nalazi na flajeru!</div>
            </div>
            <div className="line-box line-box-2">
              <div className="title title-2">UNESI</div>
              <div className="desc desc-2">IME PREZIME I EMAIL</div>
            </div>
            <div className="line-box line-box-3">
              <div className="title title-3">UČESTVUJ</div>
              <div className="desc desc-3">U KVIZU I OSVOJI SJAJNE NAGRADE</div>
            </div>
            <div className="quiz-button-box">
              <button
                className="quiz-button"
                onClick={() => navigate('/prijava')}
              >
                KLIKNI DA POKRENEŠ KVIZ
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='divglavna'>
        <h1 className='text-galvna'>GLAVNA NAGRADA</h1>
        <div className="linija">
            {/* <img src="../PRESS.png" alt="Divider" className="linija-slika" /> */}
        </div>
        <h2 className='text-yamaha'>AOC AGON MONITOR</h2>
      </div>
    </section>
  );
};

export default MechanismSection;



// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import '../App.scss';

// const MechanismSection: React.FC = () => {
//   const navigate = useNavigate();

//   return (
//     <section id="mehanizam" className="mechanism-section">
//       <div className="mech-wrapper">
//         {/* Leva strana: tekst i motor */}
//         <div className="mech-left">
//           <h2 className="font-upercase">NAGRADNI KONKURS KOJI VOZI!</h2>
//           <h3 className="font-secondary-title">OSVOJI MONSTER ENERGY YAMAHA MOTOR</h3>
//           <img src="../motor-senka.png" alt="Yamaha motor" className="mech-motor" />
//         </div>

//         {/* Desna strana: zelena tabela kao pozadina + tekst preko */}
//         <div className="mechanism-scale-wrapper">
//           <div className="mechanism-scale-inner">
//             <div className="line-box">
//               <div className="title">KUPI</div>
//               <div className="desc">BILO KOJA DVA PROIZVODA MONSTER 0,5L</div>
//             </div>
//             <div className="line-box">
//               <div className="title">UNESI</div>
//               <div className="desc">PFR SA FISKALNOG RAČUNA</div>
//             </div>
//             <div className="line-box">
//               <div className="title">UČESTVUJ</div>
//               <div className="desc">U KVIZU I OSVOJI SJAJNE NAGRADE</div>
//             </div>
//             <div className="quiz-button-box">
//               <button
//                 className="quiz-button"
//                 onClick={() => navigate('/prijava')}
//               >
//                 KLIKNI DA POKRENEŠ KVIZ
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default MechanismSection;
